module.exports = __webpack_public_path__ + "img/al.673a2c7b.svg";